module.exports = __webpack_public_path__ + "img/analyzer.8af09322.png";